import './LearningFeed.css';
import LearningPost from "./LearningPost.jsx";

import feed from '../assets/learning-feed/feed-contents.json';

export default function LearningFeed() {
  return (
    <div className="learning-feed-main">
      {
        feed.posts.map( (post, index) => <LearningPost key={index} post={post} /> )
      }
    </div>
  )
}